import React from "react";
import { motion, AnimatePresence } from "framer-motion";

/**
 * A bottom-docked banner for announcements.
 * Supports "Don't show again" persistence.
 *
 * @param {Object} props
 * @param {string} props.text - The banner text content.
 * @param {Function} props.onClose - Callback when "X" or "Don't show" is clicked.
 * @param {Function} props.onDismiss - Callback for "Don't show again" persistent storage.
 * @returns {JSX.Element}
 */
export default function Banner({ text, onClose, onDismiss }) {
  return (
    <motion.div
      className="global-banner"
      initial={{ y: 100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: 100, opacity: 0 }}
      transition={{ type: "spring", damping: 20, stiffness: 100 }}
    >
      <div className="banner-content">
        <span className="banner-text">
          Test Text
        </span>
        <div className="banner-actions">
          <button className="banner-dismiss-btn" onClick={onDismiss}>
            Don't show again
          </button>
          <button
            className="banner-close-icon"
            onClick={onClose}
            aria-label="Close"
          >
            ✕
          </button>
        </div>
      </div>
    </motion.div>
  );
}
